import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Title } from "@vshp/ui-components";
import { useTranslation } from "react-i18next";
import { languagePathUrl } from "../utils/languagePathUrl";
import { fetchPartners } from "../../actions/partners";
import { Loading } from "../utils/loading";
import PartnerItem from "../partners/PartnerItem";
import _ from "lodash";
import i18n from "i18next";

function Partners() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let locale = i18n.language;
  const { currentLanguage } = useSelector((state) => state.global);
  const { partners, partnersAreLoading } = useSelector((state) => state.partners);

  useEffect(() => {
    if (partners.length < 1) {
      dispatch(fetchPartners(locale));
    }
  }, [dispatch]);

  useEffect(() => {
    const handleLanguageChange = () => {
      dispatch(fetchPartners(i18n.language));
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [dispatch]);

  const randomPartners = _.sampleSize(partners, 5);

  return (
    <>
      {partnersAreLoading ? (
        <Loading />
      ) : (
        <div className="page__block-body">
          <Title type="h2" data-key="partners.title">
            {t("partners.title")}
          </Title>
          <div className="page__block-body_small wysiwyg">
            <p data-key="partners.description">{t("partners.description")}</p>
          </div>
          <PartnerItem partners={randomPartners} />
          <div className="text-center">
            <Link className="btn btn_primary btn_max-width-sm" to={`${languagePathUrl(currentLanguage)}/partners`} data-key="partners.show_all">
              {t("partners.show_all")}
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Partners;
